import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=ff3823d8&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=ff3823d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3823d8",
  null
  
)

export default component.exports